import { Link } from "react-router-dom";
import { approvedBriefPath } from "../../lib/approval-display";

export type ApprovedNotice = { id: string; title: string; campaign_id: string };

/**
 * Shown after Approve in Review. The approved draft leaves the queue at once, so without this the
 * operator saw it simply disappear. Approval never publishes; the banner says so.
 */
export function ApprovalConfirmation({ brandId, approved, onViewApproved, onDismiss }: {
  brandId: string;
  approved: ApprovedNotice;
  onViewApproved: () => void;
  onDismiss: () => void;
}) {
  return (
    <div role="status" className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-[20px] border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
      <p className="min-w-0 flex-1">
        <span className="font-semibold">Approved “{approved.title}”.</span>{" "}
        Nothing was published. It moved to Approved, where you can open it again.
      </p>
      <button type="button" onClick={onViewApproved} className="min-h-11 font-medium text-brand-700 hover:underline">View approved</button>
      <Link to={approvedBriefPath(brandId, approved.campaign_id, approved.id)} className="inline-flex min-h-11 items-center font-medium text-brand-700 hover:underline">Open brief</Link>
      <button type="button" onClick={onDismiss} aria-label="Dismiss approval confirmation" className="min-h-11 px-2 text-emerald-800 hover:text-emerald-950">×</button>
    </div>
  );
}
